import Vue from "vue";
import Vuex from "vuex";
import { auth } from "./modules/auth";
import { organizations } from "./modules/organizations";
import { meetings } from "./modules/meetings";
import { contracts } from "./modules/contacts";
import { snackbar } from "./modules/snackbar";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    organizations,
    meetings,
    contracts,
    snackbar
  }
});
